// src/hooks/useUserClinicMapping.js
import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot, getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebase/firebaseApp";

export function useUserClinicMapping({ uid }) {
  const db = useMemo(() => getFirestore(firebaseApp), []);

  const [state, setState] = useState({
    loading: true,
    resolved: false,
    id: null,
    clinicStudyId: null,
    updatedAt: null,
    error: null,
  });

  useEffect(() => {
    if (!uid) {
      setState({
        loading: false,
        resolved: false,
        id: null,
        clinicStudyId: null,
        updatedAt: null,
        error: null,
      });
      return;
    }

    setState((prev) => ({
      ...prev,
      loading: true,
      resolved: false,
      error: null,
    }));

    const ref = doc(db, "user_clinic_mapping", uid);

    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) {
          setState({
            loading: false,
            resolved: true,
            id: null,
            clinicStudyId: null,
            updatedAt: null,
            error: null,
          });
          return;
        }

        const data = snap.data() || {};
        setState({
          loading: false,
          resolved: true,
          id: data.id ?? null,
          clinicStudyId: data.clinicStudyId ?? null,
          updatedAt: data.updatedAt ?? null,
          error: null,
        });
      },
      (err) => {
        setState({
          loading: false,
          resolved: true,
          id: null,
          clinicStudyId: null,
          updatedAt: null,
          error: err?.message ? String(err.message) : "fetch_failed",
        });
      },
    );

    return () => unsub();
  }, [uid, db]);

  return state;
}
